"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ADD_INJURY: function() {
        return ADD_INJURY;
    },
    DELETE_INJURY: function() {
        return DELETE_INJURY;
    },
    DUPLICATE_INJURY: function() {
        return DUPLICATE_INJURY;
    },
    GENERATE_INJURYS: function() {
        return GENERATE_INJURYS;
    },
    RESET_INJURYS: function() {
        return RESET_INJURYS;
    },
    UPDATE_INJURY: function() {
        return UPDATE_INJURY;
    }
});
const ADD_INJURY = "ADD_INJURY";
const UPDATE_INJURY = "UPDATE_INJURY";
const DELETE_INJURY = "DELETE_INJURY";
const GENERATE_INJURYS = "GENERATE_INJURYS";
const RESET_INJURYS = "RESET_INJURYS";
const DUPLICATE_INJURY = "DUPLICATE_INJURY";
